
import { SkyBoxRoutesEnum } from "models/enums/apiRoutes/skyBoxApiRoutes";


import { IApiBaseResponse } from "models/interfaces/Iglobal";
import axiosClient from "sharedServices/api/axios.services";
export class BotPerformanceDashboardService {
    public getBotPerformanceData = async () => {
      return axiosClient.get<IApiBaseResponse<any>>(
        SkyBoxRoutesEnum.DASHBOARD_BOT_PERFORMANCE_DATA,
        {
          params: null,
        }
      );
    };
}